<app-loader *ngIf="isActiveLoader"></app-loader>
<div class="container-app-2 d-flex flex-column min-vh-100">
  <app-header class="sticky"></app-header>

  <div class="container pb-container-300 mt-container-330 adjust-content" [hidden]="!isLoadingModule">
    <div class="row justify-content-center spin-load">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="dynamic-content adjust-content container" [hidden]="isLoadingModule">
    <router-outlet></router-outlet>
  </div>

  <app-footer class="mt-auto"></app-footer>
</div>
